export default {
  common_canNotBeEmpty: 'Non può essere vuoto',
  // #region首页
  main_collection_function: 'Funzione Preferiti',
  main_menu_bar_management: 'Gestione Barra dei Menu',
  // #endregion

  // #region Header
  main_header_download_app: 'Scarica APP',
  main_header_recent_visit: 'Visitati di Recente',
  main_header_placeholder: 'Cerca',
  main_header_IT_system: 'Sistema IT',
  main_header_todo_center: 'Centro Attività',
  main_header_message_remind: 'Promemoria Messaggi',
  main_header_change_SYS_password: 'Cambia Password',
  main_header_log_out: 'Esci',
  main_header_log_out_tip: 'Confermi di voler uscire?',
  main_header_log_out_title: 'Conferma Uscita',
  main_header_confirm: 'Conferma',
  main_header_cancel: 'Annulla',
  main_header_change_name: 'Nome',
  main_header_change_Work_number: 'Matricola',
  main_header_old_password: 'Vecchia Password',
  main_header_old_password_placeholder: 'Inserisci la password iniziale',
  main_header_new_password: 'Nuova Password',
  main_header_new_password_placeholder: 'Inserisci una nuova password',
  main_header_confirm_password: 'Conferma Password',
  main_header_confirm_password_placeholder: 'Conferma la password',
  main_header_messageObj_prompt: 'Promemoria',
  main_header_messageObj_length: 'La password deve essere lunga 8~16 caratteri',
  main_header_messageObj_three_condition: 'Deve contenere almeno 3 tipi tra: lettere maiuscole, minuscole, numeri, simboli speciali',
  main_header_messageObj_no_repeat: 'Non sono consentiti 3 o più numeri consecutivi o ripetuti (es. 345, 333)',
  main_header_messageObj_old_new_different: 'La nuova password non può essere uguale alla vecchia',
  main_header_messageObj_twice_different: 'Le due password inserite devono coincidere',
  main_header_change_success: 'Modifica riuscita',
  main_header_refresh: 'Aggiorna',
  main_header_close: 'Chiudi',
  main_header_close_all: 'Chiudi Tutto',
  main_header_close_addition: 'Chiudi Tutto Tranne Questo',
  main_header_close_right: 'Chiudi Tutto a Destra',
  main_header_close_left: 'Chiudi Tutto a Sinistra',
  // #endregion

  // #region 首页
  main_home_home_name: 'Home',
  main_home_todo_title: 'Le Mie Attività',
  main_home_todo_more: 'Altro',
  main_home_todo_checkAll: 'Seleziona Tutto',
  main_home_todo_batchProcess: 'Elabora in Batch',
  main_home_todo_complaint: 'Riassegna',
  main_home_todo_approve: 'Approva',
  main_home_todo_reject: 'Rifiuta',
  main_home_todo_toDealWith: 'Gestisci',
  main_home_todo_work_dealed: 'Congratulazioni! Hai completato tutto il lavoro!',
  main_home_todo_no_data: 'Nessun dato disponibile',
  main_home_todo_current_select: 'Attualmente selezionati',
  main_home_todo_data_num: 'elementi di dati',
  main_home_todo_all: 'Tutti',
  main_home_todo_approve_tip: 'Confermi di approvare questi dati?',
  main_home_todo_approve_title: 'Approva',
  main_home_todo_confirm: 'Conferma',
  main_home_todo_cancel: 'Annulla',
  main_home_todo_approve_success: 'Approvato con successo!',
  main_home_todo_reject_title: 'Rifiuta',
  main_home_todo_reject_reason: 'Inserisci il motivo del rifiuto',
  main_home_todo_reject_success: 'Rifiutato con successo!',
  main_home_quick_title: 'Accesso Rapido',
  main_home_quick_create: 'Crea Collegamento',
  main_home_quick_cancel_common: 'Rimuovi dai Preferiti',
  main_home_quick_set_common: 'Imposta come Preferito',
  main_home_quick_sort: 'Ordina',
  main_home_quick_recommend: 'Imposta come App Consigliata',
  main_home_quick_add_common: 'Aggiungi ai Preferiti',
  main_home_quick_no_data: 'Nessun dato disponibile',
  main_home_quick_cancel_common_success: 'Rimosso dai Preferiti con successo!',
  main_home_quick_set_common_success: 'Impostato come Preferito con successo!',
  main_home_quick_recommend_success: 'Impostato come App Consigliata con successo!',
  main_home_report_transhipment: 'Transhipment - Trasporto Aereo',
  main_home_report_no_data: 'Nessun dato disponibile',
  main_home_report_clearance: 'Dogana - Documenti di Sdoganamento',
  main_home_report_risk_control: 'Dogana - Controllo del Rischio',
  main_home_micro_loading: 'Caricamento sistema...',
  main_header_full_screen: 'Schermo Intero',
  main_header_exit_full_screen: 'Esci da Schermo Intero',
  main_header_forced_refresh: 'Forza Aggiornamento',
  // #endregion

  // #region request tips
  main_request_tip_exist_environ: 'Ambiente inesistente',
  main_request_tip_login_expired: 'Accesso scaduto, effettua nuovamente il login',
  main_request_tip_no_legal: 'Nessuna autorizzazione, contatta l\'amministratore',
  main_request_tip_server_error: 'Errore del server, contatta l\'amministratore',
  main_request_504_error: 'Timeout del gateway, riprova',
  main_request_tip_system_error: 'Errore di sistema, contatta l\'amministratore',
  main_request_tip_timeout: 'Timeout della richiesta, aggiorna e riprova',
  main_request_copy_success: 'Copiato con successo',
  main_request_tip_confirm: 'Conferma',
  main_request_tip_cancel: 'Annulla',
  main_request_tip_delete_success: 'Eliminato con successo',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: 'Benvenuto nel Sistema GOFO',
  main_login_loading_failure: 'Caricamento ambiente fallito, aggiorna e riprova',
  main_login_morning_greetings: 'Buongiorno',
  main_login_noon_greetings: 'Buongiorno',
  main_login_afternoon_greetings: 'Buon pomeriggio',
  main_login_night_greetings: 'Buonasera',
  main_login_account: 'Numero di telefono',
  main_login_placeholder_input: 'Inserisci',
  main_login_password: 'Password',
  main_login_retrieve_password: 'Recupera Password',
  main_login_btn_text: 'Accedi',
  main_login_account_tip: 'Inserisci il tuo numero di telefono',
  main_login_password_tip: 'Inserisci la tua password',
  main_login_account_error: 'Account o password errati',
  main_login_retrieve_back: 'Indietro',
  main_login_select_account: 'Seleziona Account da Recuperare',
  main_login_select_way: 'Scegli Metodo di Recupero',
  main_login_authentication: 'Verifica Identità',
  main_login_reset_password: 'Reimposta Password',
  main_login_work_number: 'Matricola',
  main_login_work_number_tip: 'Inserisci la matricola da recuperare',
  main_login_customer_tip: 'Stai eseguendo un\'operazione di reimpostazione della password per',
  main_login_operation_tip: 'per reimpostare la password',
  main_login_verification_code: 'Clicca per ottenere il codice di verifica, l\'email sarà inviata alla tua casella',
  main_login_verification_code_tip: 'Inserisci il codice di verifica',
  main_login_send_verification_code: 'Invia Codice di Verifica',
  main_login_name: 'Nome',
  main_login_new_password: 'Nuova Password',
  main_login_new_password_tip: 'Inserisci una nuova password',
  main_login_new_password_again_tip: 'Inserisci nuovamente la nuova password',
  main_login_next_step: 'Avanti',
  main_login_save: 'Salva',
  main_login_reset_password_succeeded: 'Reimpostazione password riuscita, accedi nuovamente',
  main_login_work_number_input: 'Inserisci la matricola',
  main_login_six_verification_code: 'Inserisci il codice di verifica a 6 cifre',
  main_login_mail: 'Tramite Email',
  main_login_unknown_way: 'Metodo di verifica sconosciuto',
  main_login_get_in: 'Ingresso nel sistema in corso, attendere',
  main_login_no_exist_page: 'Non hai l\'autorizzazione o questa pagina non esiste',
  main_login_no_exist_page_tip: 'Controlla se il percorso è corretto, o clicca il pulsante per tornare alla home. In caso di problemi, contatta l\'amministratore',
  main_login_no_exist_back: 'Torna alla Home',
  main_login_no_last_back: 'Torna alla Pagina Precedente',
  main_login_link_not_exist: 'Il link non esiste',
  main_login_privacy_agree: 'Continuare significa accettare i nostri',
  main_login_privacy_title_1: 'Condizioni di servizio',
  main_login_privacy_confirm: 'Confermato e letto',
  main_login_privacy_title_2: 'Politica sulla privacy',
  main_login_privacy_tip: 'Prima di effettuare il login, leggere e accettare le nostre',
  main_login_privacy_think_btn: 'Ripensare',
  main_login_privacy_agree_btn: 'Accettare',
  main_login_privacy_with: 'E'
  // #endregion
}
